import { useContext } from "react";
import { TravelContext } from "../context/travel";

const useTravel = () => useContext(TravelContext);

export default useTravel;
